import React, { useEffect, useRef, useState } from 'react'
import styles from './StatsSection.module.css'
import { useLang } from '../../i18n/LanguageContext'

const NUMBERS = [
  { number: 60,  suffix: 'k+', decimals: 0 },
  { number: 7.2, suffixPT: 'mi', suffixEN: 'M', decimals: 1 },
  { number: 31,  suffix: '%',  decimals: 0 },
  { number: 12,  suffix: '+',  decimals: 0 },
]

function AnimatedNumber({ end, suffix = '', decimals = 0, lang = 'pt' }) {
  const [value, setValue] = useState(0)
  const ref = useRef(null)
  const started = useRef(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true
          const duration = 1800
          const startTime = performance.now()
          const step = (now) => {
            const elapsed = now - startTime
            const progress = Math.min(elapsed / duration, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            setValue(eased * end)
            if (progress < 1) requestAnimationFrame(step)
          }
          requestAnimationFrame(step)
        }
      },
      { threshold: 0.5 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [end])

  const sep = lang === 'pt' ? ',' : '.'
  const display = decimals > 0
    ? value.toFixed(decimals).replace('.', sep)
    : Math.round(value).toLocaleString(lang === 'pt' ? 'pt-BR' : 'en-US')

  return <span ref={ref}>{display}{suffix}</span>
}

export default function StatsSection() {
  const { lang, T } = useLang()

  return (
    <section className={styles.stats}>
      <div className="container">
        <div className={styles.grid}>
          {NUMBERS.map((n, i) => {
            const suffix = n.suffixPT ? (lang === 'pt' ? n.suffixPT : n.suffixEN) : n.suffix
            const s = T.stats[i]
            return (
              <div key={i} className={styles.item}>
                <div className={styles.value}>
                  <AnimatedNumber end={n.number} suffix={suffix} decimals={n.decimals} lang={lang} />
                </div>
                <div className={styles.label}>{s.label}</div>
                <div className={styles.detail}>{s.detail}</div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
